export default "__VITE_ASSET__CFYcGqxq__"